import { useNavigate } from 'react-router-dom';

interface SignupTypeSelectorProps {
  className?: string;
}

export function SignupTypeSelector({ className = '' }: SignupTypeSelectorProps) {
  const navigate = useNavigate();

  const handleBuyerSignup = () => {
    navigate('/signup/buyer');
  };

  const handleSellerSignup = () => {
    navigate('/signup/seller');
  };

  return (
    <div className={`space-y-4 ${className}`}>
      <button
        onClick={handleBuyerSignup}
        className="w-full h-[72px] bg-[#CCEFCC] text-[#222222] font-semibold text-[24px] rounded-xl hover:bg-[#B5E5B5] transition-colors"
      >
        사고 싶어요 (일반 소비자)
      </button>
      <button
        onClick={handleSellerSignup}
        className="w-full h-[72px] bg-[#FFEFE0] text-[#222222] font-semibold text-[24px] rounded-xl hover:bg-[#FFE5CC] transition-colors"
      >
        팔고 싶어요 (사업자)
      </button>
    </div>
  );
}